export default "<div id=\"oauth-callback\" ng-init=\"connection.init()\">\n</div>\n"